import { CutNode } from '../const';
const DEFAULT_PLACEHOLDERS = {
    Title: 'Cut title',
    Content: 'Cut content',
};
export const getSpec = (opts, placeholder) => {
    var _a, _b, _c, _d;
    return ({
        [CutNode.Cut]: {
            attrs: { class: { default: 'yfm-cut' } },
            content: `${CutNode.CutTitle} ${CutNode.CutContent}`,
            group: 'block yfm-cut',
            parseDOM: [{ tag: 'div.yfm-cut' }],
            toDOM(node) {
                return ['div', node.attrs, 0];
            },
            selectable: true,
            allowSelection: true,
            defining: true,
            complex: 'root',
        },
        [CutNode.CutTitle]: {
            attrs: { class: { default: 'yfm-cut-title' } },
            content: 'inline*',
            group: 'block yfm-cut',
            parseDOM: [{ tag: 'div.yfm-cut-title' }],
            toDOM(node) {
                return ['div', node.attrs, 0];
            },
            placeholder: {
                content: (_b = (_a = placeholder === null || placeholder === void 0 ? void 0 : placeholder[CutNode.CutTitle]) !== null && _a !== void 0 ? _a : opts === null || opts === void 0 ? void 0 : opts.yfmCutTitlePlaceholder) !== null && _b !== void 0 ? _b : DEFAULT_PLACEHOLDERS.Title,
                alwaysVisible: true,
            },
            definingAsContext: true,
            selectable: false,
            allowSelection: false,
            complex: 'leaf',
        },
        [CutNode.CutContent]: {
            attrs: { class: { default: 'yfm-cut-content' } },
            content: '(block | paragraph)+',
            group: 'block yfm-cut',
            parseDOM: [{ tag: 'div.yfm-cut-content' }],
            toDOM(node) {
                return ['div', node.attrs, 0];
            },
            placeholder: {
                content: (_d = (_c = placeholder === null || placeholder === void 0 ? void 0 : placeholder[CutNode.CutContent]) !== null && _c !== void 0 ? _c : opts === null || opts === void 0 ? void 0 : opts.yfmCutContentPlaceholder) !== null && _d !== void 0 ? _d : DEFAULT_PLACEHOLDERS.Content,
                alwaysVisible: true,
            },
            definingAsContext: true,
            selectable: false,
            allowSelection: false,
            complex: 'leaf',
        },
    });
};
